<div [ngSwitch]="viewType">
  <div *ngSwitchCase="'ttw'">
    <ng-container [ngTemplateOutlet]="ttwLayout"></ng-container>
  </div>
  <div *ngSwitchCase="'rear-loading-reclaim'" class="rear-container">
    <ng-container
      [ngTemplateOutlet]="commonLayout"
      [ngTemplateOutletContext]="{ type: 'rear', clickHandler: handleSelectedSpace.bind(this) }"
    ></ng-container>
  </div>
  <div *ngSwitchCase="'front-loading-reclaim'">
    <ng-container
      [ngTemplateOutlet]="commonLayout"
      [ngTemplateOutletContext]="{ type: 'front', clickHandler: handleSelectedSpace.bind(this) }"
    ></ng-container>
  </div>
  <div *ngSwitchCase="'front-loading-loading-order'">
    <ng-container
      [ngTemplateOutlet]="commonLayout"
      [ngTemplateOutletContext]="{ type: 'front', clickHandler: handleSelectedSpace.bind(this) }"
    ></ng-container>
  </div>
</div>

<ng-template #ttwLayout>
  <div
    *ngFor="let space of spaces"
    class="space-box"
    [ngStyle]="getStyle(space)"
    [ngClass]="getSpaceClass(space, 'front')"
    id="{{ 'space_' + space.hardwareInfo.position }}"
  >
    <img *ngIf="!space.hardwareInfo.position" src="/assets/lockerUI.svg" alt="HMI" class="hmi" />
    <p [ngClass]="getOpenedDoorClass(space)">{{ space.hardwareInfo.position }}</p>
    <img
      *ngIf="positions.includes(space.hardwareInfo.position)"
      src="/assets/openDoor.svg"
      alt="opened-door"
      class="opened-door"
    />
  </div>
</ng-template>

<ng-template #commonLayout let-type="type" let-clickHandler="clickHandler">
  <div
    *ngFor="let space of spaces"
    class="space-box"
    [ngStyle]="getStyle(space)"
    [ngClass]="getSpaceClass(space, type)"
    (click)="clickHandler(space)"
    id="{{ 'space_' + space.hardwareInfo.position }}"
  >
    <img *ngIf="!space.hardwareInfo.position" src="/assets/lockerUI.svg" alt="HMI" class="hmi" />
    <p>{{ space.hardwareInfo.position }}</p>
    <div *ngIf="space.dispenses && space.dispenses.length; else fault">
      <p class="schedule-name">{{ space.dispenses?.[0]?.scheduleInfo?.scheduleName }}</p>
      <p class="timer" [ngClass]="getTimerClass(space)">
        {{ getDispenseTime(space) }}
      </p>
    </div>
    <ng-template #fault>
      <p class="fault" *ngIf="isSpaceFaulty(space)">{{ 'common.fault' | translate }}</p>
    </ng-template>
  </div>
</ng-template>
